import React from 'react';

import spotlightIcon from 'assets/sidebar-spotlight.svg';

const SidebarSpotlightIcon = ({
  className,
  id,
  onClick,
}: {
  className?: string;
  id?: string;
  onClick: () => void;
}): JSX.Element => (
  <img
    alt="spotlight-icon"
    className={className}
    id={id}
    onClick={onClick}
    src={spotlightIcon}
  />
);

export default SidebarSpotlightIcon;
